import { resolve } from "path";
import Vue from "vue";
import { SupportedFilePreviewFormats } from "../../lib/utilities/enums";
import { HelperFunctions } from "../../lib/utilities/HelperFunctions";

const getDefaultTemplateCategory = () => ({ Id: 0, Name: "Browse all" });

function initialState() {
  return {
    TemplateCollection: [],
    TemplateTags: [],
    TemplateTokens: [],
    TemplateParameters: {},
    SelectedStore: {},
    ShowEmailPreviewModal: false,
    ShowSaveAsModal: false,
    ShowChangeTemplateChannelModal: false,
    TemplateUsers: [],
    ShowTemplateDeleteModal: false,
    ShowTemplateRevertModal: false,
    TemplateChangeLog: [],
    TemplateChangeLogUsers: [],
    ShowTemplateChangeLogModal: false,
    DealerEmailTemplates: [],
    ImageGalleryModalInfo: {
      showModal: false
    },
    TemplateLookupEnums: {
      Categories: [],
      Channels: [],
      Contexts: [],
      TemplateTypes: []
    },
    CopyEnterpriseTemplatesModalInfo: {
      data: null,
      showModal: false
    },
    CopyIndividualTemplateModalInfo: {
      data: null,
      showModal: false
    },
    TemplateStore: null
  };
}

const state = initialState();

const actions = {
  async getTemplateLookupEnums(context) {
    let response = await Vue.http.get("templatemanager/gettemplatelookups").catch(err => err.response);
    if (response && response.data) context.commit("updateTemplateLookupEnums", response.data.Data);
  },
  loadTemplateTags: function (context, tags) {
    context.commit("loadTemplateTags", tags);
  },
  loadTemplateCollection: function (context, params) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/templatemanager/getDealerTemplates", params)
        .then(response => {
          if (response.data.Success) {
            let dealerTemplates = response.data.Data;
            context.commit("loadTemplateCollection", dealerTemplates);
            resolve(dealerTemplates);
          } else {
            reject(response.data.Data);
          }
        })
        .catch(error => reject(error));
    });
  },
  updateTemplateCollection: function (context, collection) {
    context.commit("updateTemplateCollection", collection);
  },
  getTemplateTokens: function (context, param) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get(
          "templatemanager/getTemplateTokensByPlatformId?platformId=" + param
        )
        .then(function (data) {
          let templateTokens = data.data ? data.data.Data : [];
          context.commit("loadTemplateTokens", templateTokens);
          resolve(templateTokens);
        })
        .catch(error => reject(error));
    });
  },
  saveDealerTemplate: function (context, param) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/templatemanager/dealer/savedealertemplate", param)
        .then(function (data) {
          context.commit("refreshDealerTemplates", param.AccountPlatformId);
          resolve(data.data);
        })
        .catch(error => reject(error));
    });
  },
  getTemplateUsers: function (context, param) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/users", param)
        .then(function (data) {
          let templateUsers = data.data.Data;
          context.commit("updateTemplateUsers", templateUsers);
          resolve(templateUsers);
        })
        .catch(error => reject(error));
    });
  },
  getChangeLogUsers: function (context, param) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/users", param)
        .then(function (data) {
          let changeLogUsers = data.data.Data;
          context.commit("updateChangeLogUsers", changeLogUsers);
          resolve(changeLogUsers);
        })
        .catch(error => reject(error));
    });
  },
  deleteTemplate: function (context, param) {
    return new Promise((resolve, reject) => {
      Vue.http
        .delete(
          "/templatemanager/dealer/deleteTemplate/" +
          param.accountPlatformId +
          "/" +
          param.templateIdToDelete
        )
        .then(function (data) {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  revertTemplate: function (context, param) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get(
          "/templatemanager/dealer/revertTemplate/" +
          param.accountPlatformId +
          "/" +
          param.templateIdToRevert
        )
        .then(function (data) {
          if (data.data.Success) {
            context.commit("updateTemplateParameters", data.data.Data);
          }
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getPdf: function (context, param) {
    return Vue.http.post("/templatemanager/getPdf", param);
  },
  updateEditTemplatePageInfo(context, data) {
    context.commit("updateTemplateParameters", data.template);
  },
  updateTemplateParameters: function (context, template) {
    context.commit("updateTemplateParameters", template);
  },
  updateShowEmailPreviewModal: function (context, showModal) {
    context.commit("updateShowEmailPreviewModal", showModal);
  },
  updateChangeTemplateChannelModal: function (context, data) {
    context.commit("updateChangeTemplateChannelModal", data);
  },
  updateShowSaveAsModal: function (context, showModal) {
    context.commit("updateShowSaveAsModal", showModal);
  },
  updateTemplateUsers: function (context, templates) {
    context.commit("updateTemplateUsers", templates);
  },
  updateShowTemplateDeleteModal: function (context, showModal) {
    context.commit("updateShowTemplateDeleteModal", showModal);
  },
  updateShowTemplateRevertModal: function (context, showModal) {
    context.commit("updateShowTemplateRevertModal", showModal);
  },
  getTemplateChangeLog: function (context, param) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/templatemanager/gettemplatechangelog", param)
        .then(function (data) {
          let templateChangeLog = data.data.Data.ChangeLog;
          context.commit("updateTemplateChangeLog", templateChangeLog);
          resolve(templateChangeLog);
        })
        .catch(error => reject(error));
    });
  },
  updateShowTemplateChangeLogModal: function (context, showModal) {
    context.commit("updateShowTemplateChangeLogModal", showModal);
  },
  clearTemplateChangeLog: function (context) {
    context.commit("clearTemplateChangeLog");
  },
  updateChangeLogUsers: function (context, param) {
    context.commit("updateChangeLogUsers", param);
  },
  async getEmailTemplatesForPlatform(context, accountPlatformId) {    
    if (!state.TemplateLookupEnums || (state.TemplateLookupEnums.Categories || []).length == 0)
      await context.dispatch("getTemplateLookupEnums");

    let categories = JSON.parse(JSON.stringify(state.TemplateLookupEnums.Categories || []));
    let requestPayload = {
      CategoryIds: categories
        ? categories.filter(x => x.Id > 0).map(y => y.Id)
        : [],
      ChannelIds: [1],
      Statuses: [true],
      TemplateTypeId: 1,
      AccountPlatformIds: [accountPlatformId]
    };

    let response = await Vue.http.post("/templatemanager/getDealerTemplates", requestPayload);

    if (response && response.data && response.data.Success) {
      response.data.Data = (response.data.Data || []).sort(
        HelperFunctions.sortByProperty("TemplateName")
      );
      let templates = response.data.Data;
      context.commit("updateDealerEmailTemplates", {
        platformId: accountPlatformId,
        templates: templates
      });
      return templates;
    } else return [];
  },
  async uploadTinyMCEImages(context, request) {
    let response = await Vue.http.post(
      `/pando/pandox/create_email_template_attachment/${request.AccountID}/${request.AccountPlatformID}`,
      request.FileContent
    );

    if (
      response &&
      response.data &&
      response.data.Data &&
      response.data.Data[0].FilePath
    ) {
      return response.data.Data[0].FilePath;
    }
    return null;
  },
  updateImageGalleryModal: function (context, data) {
    context.commit("updateImageGalleryModal", data);
  },
  updateCopyEnterpriseTemplatesModalInfo(context, data) {
    context.commit("updateCopyEnterpriseTemplatesModalInfo", data)
  },
  async copyDealerTemplates(context, payload) {
    let response = await context.getters.CxmApiClient.ProcessRequest("POST", "/template/copyDealerTemplate/queueRequest", payload);
    return response && response.data ? response.data.data : null;
  },
  updateCopyIndividualTemplateModalInfo(context, data) {
    context.commit("updateCopyIndividualTemplateModalInfo", data)
  },
  updateTemplateStore(context, store) {
    context.commit("updateTemplateStore", store);
  }
};

const mutations = {
  updateTemplateLookupEnums(state, data) {
    state.TemplateLookupEnums.Categories = (data || {}).Categories || [];
    state.TemplateLookupEnums.Channels = (data || {}).Channels || [];
    state.TemplateLookupEnums.Contexts = (data || {}).Contexts || [];
    state.TemplateLookupEnums.TemplateTypes = (data || {}).TemplateTypes || [];
  },
  loadTemplateTags: function (state, tags) {
    state.TemplateTags = tags;
  },
  loadTemplateCollection: function (state, data) {
    state.TemplateCollection = data;
  },
  loadTemplateTokens: function (state, data) {
    state.TemplateTokens = data;
  },
  updateTemplateCollection: function (state, data) {
    state.TemplateCollection = data;
  },
  updateTemplateParameters: function (state, template) {
    state.TemplateParameters = template;
  },
  updateShowEmailPreviewModal: function (state, showModal) {
    state.ShowEmailPreviewModal = showModal;
  },
  updateShowSaveAsModal: function (state, showModal) {
    state.ShowSaveAsModal = showModal;
  },
  updateChangeTemplateChannelModal: function (state, showModal) {
    state.ShowChangeTemplateChannelModal = showModal;
  },
  updateTemplateUsers: function (state, users) {
    state.TemplateUsers = users;
  },
  updateShowTemplateDeleteModal: function (state, showModal) {
    state.ShowTemplateDeleteModal = showModal;
  },
  updateShowTemplateRevertModal: function (context, showModal) {
    state.ShowTemplateRevertModal = showModal;
  },
  updateTemplateChangeLog: function (state, changeLog) {
    state.TemplateChangeLog = changeLog;
  },
  updateShowTemplateChangeLogModal: function (state, showModal) {
    state.ShowTemplateChangeLogModal = showModal;
  },
  clearTemplateChangeLog: function (state) {
    state.TemplateChangeLog = [];
  },
  updateChangeLogUsers: function (state, users) {
    state.changeLogUsers = users;
  },
  updateDealerEmailTemplates: function (state, data) {
    let activeTemplates = data.templates ? data.templates : [];
    state.DealerEmailTemplates.push({
      platformId: data.platformId,
      templates: activeTemplates.sort(
        HelperFunctions.sortByProperty("TemplateName")
      )
    });
  },
  refreshDealerTemplates: function (state, platformId) {
    let existingDealers = state.DealerEmailTemplates;
    if (
      existingDealers &&
      existingDealers.some(x => x.platformId == platformId)
    )
      state.DealerEmailTemplates = existingDealers.filter(
        x => x.platformId != platformId
      );
  },
  updateCopyEnterpriseTemplatesModalInfo(state, data) {
    state.CopyEnterpriseTemplatesModalInfo = data;
  },
  updateCopyIndividualTemplateModalInfo(state, data) {
    state.CopyIndividualTemplateModalInfo = data;
  },
  updateTemplateStore(state, store) {
    state.TemplateStore = store;
  }
};

const getters = {
  DealerEmailTemplates: state => platformId => {
    if (state.DealerEmailTemplates && state.DealerEmailTemplates.length > 0)
      return state.DealerEmailTemplates.find(x => x.platformId == platformId);
    return null;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/Templates.js